module.exports = {
  1: 18337329,
  5: 9854680,
  30: 5717948,
  31: 4378661,
  40: 305834078,
  41: 262335361,
  56: 32550529,
  97: 34150670,
  137: 48645401,
  8453: 5180096,
  17000: 890721,
  42161: 140046382,
  43113: 26720218,
  43114: 36367783,
  59140: 1711053,
  59144: 619127,
  80001: 41133390,
  84531: 10978032,
  421613: 47402006,
  11155111: 4509265,
  245022926: 308305928,
  245022934: 277791732,
}
